import React from 'react';
import js from '../skill logos/javascript.png'
import react from '../skill logos/react.png'
import py from '../skill logos/python.png'
import css from '../skill logos/css.png'
import html from '../skill logos/html.png'
import './Skill1.css'
const Skill1 = () => {
    const skills =[{
        log:react,
        title:'React'
    },{
        log:html,
        title:"HTML"
    },{
        log:css,
        title:"CSS"
    },{
        log:js,
        title:"JS"
    },{
        log:py,
        title:"Python"
    },]
    return (
        <div className='Skill1' id='Skills'>
            <h1>SKILLS</h1>
            <h5>My Technical Level</h5>
            <div className='Skill_container'>
            {skills.map((skill)=>(
            
                <div className='skill_card'>
                <img className={'skim'} src={skill.log}></img>
                <h5>{skill.title}</h5>
                </div>
                    
            ))}
             </div> 
        </div>
    );
};

export default Skill1;